export const productivityStates = {
  PRODUCTIVE: 'PRODUCTIVE',
  UNPRODUCTIVE: 'UNPRODUCTIVE',
  NEUTRAL: 'NEUTRAL'
}
